import { Button, Container } from "components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import './ErrorMessage.scss';

export const ErrorMessage = ({ error, continueURL }: { error: string, continueURL?: string }) => {
  continueURL = continueURL || '../';

  const { t } = useTranslation(['common', 'admin']);
  const history = useHistory();
  
  const continueButton = () => {
    history.push(continueURL!);
  }

  return <Container className='error-message'>
    <span>
      {error}
    </span>
    <Button small onClick={continueButton}>{t('common:actions.back')}</Button>
  </Container>
};
